import { SetStateAction, Dispatch, useEffect, useState } from "react"
import { CustomField, SettingMultiMeetings, SettingMultiMerchants, SettingMultiPipelines, SettingMultiReimbursements } from "../interfaces/Settings"
import { FormikProps } from "formik"
import { SelectOption } from "../interfaces/SelectOption"

interface useGetTemplateCustomFieldProps {
    data: SettingMultiPipelines | SettingMultiMerchants | SettingMultiMeetings | SettingMultiReimbursements
    dataPipeline: SelectOption[]
    dataMerchant: SelectOption[]
    dataMeeting: SelectOption[]
    formikCustomColumn: any
    type: "Database Pipeline" | "Database Merchant" | "Database Meeting" | "Database Reimbursement"
}

const useGetTemplateCustomField = ({ data, dataPipeline, dataMerchant, dataMeeting, formikCustomColumn, type }: useGetTemplateCustomFieldProps) => {
    const [valueMultiCustomField, setValueMultiCustomField] = useState<CustomField>({})
    const [keysMultiCustomField, setKeysMultiCustomField] = useState<string[]>([])

    useEffect(() => {
        formikCustomColumn.setFieldValue('value', data.name ? data.name : type)
        if (data.customFields) {
            const modifiedData = Object.fromEntries(
                Object.entries(data.customFields).map(([key, field]) => {
                    const { new: _, ...rest } = field;

                    if (data.customFields[key].type === 'pipeline') {
                        rest.value = rest.value.length === 0 ? ['all'] : rest.value.length === dataPipeline.filter((item: any) => item.value !== 'all').length ? ['all'] : rest.value;
                    }

                    if (data.customFields[key].type === 'merchant') {
                        rest.value = rest.value.length === 0 ? ['all'] : rest.value.length === dataMerchant.filter((item: any) => item.value !== 'all').length ? ['all'] : rest.value;
                    }

                    if (data.customFields[key].type === 'meeting') {
                        rest.value = rest.value.length === 0 ? ['all'] : rest.value.length === dataMeeting.filter((item: any) => item.value !== 'all').length ? ['all'] : rest.value;
                    }



                    return [key, rest];
                })
            );
            setValueMultiCustomField(modifiedData)
            setKeysMultiCustomField(Object.keys(`${modifiedData}`))
        }
    }, [data])

    const modifiedObject = Object.fromEntries(
        Object.entries(valueMultiCustomField).map(([key, field]) => {
            const { new: _, ...rest } = field;

            if (valueMultiCustomField[key].type === 'pipeline' && (valueMultiCustomField[key].value as string[]).includes('all')) {
                rest.value = dataPipeline.filter((item: any) => item.value !== 'all').map((item: any) => item.value);
            }

            if (valueMultiCustomField[key].type === 'merchant' && (valueMultiCustomField[key].value as string[]).includes('all')) {
                rest.value = dataMerchant.filter((item: any) => item.value !== 'all').map((item: any) => item.value);
            }

            if (valueMultiCustomField[key].type === 'meeting' && (valueMultiCustomField[key].value as string[]).includes('all')) {
                rest.value = dataMeeting.filter((item: any) => item.value !== 'all').map((item: any) => item.value);
            }

            return [key, rest];
        })
    );

    return {
        valueMultiCustomField,
        keysMultiCustomField,
        setValueMultiCustomField,
        setKeysMultiCustomField,
        modifiedObject
    }
}

export default useGetTemplateCustomField